<template>
  <section class="content">
    <ActionLoader
      v-if="!playlistContent.length"
      :size="1"
      class="content__loader"
    />
    <div
      class="content__group"
      v-for="(group, index) in playlistContent"
      :key="index"
    >
      <div class="content__section-title">{{ group.name }}</div>
      <div class="content__course-list">
        <div
          class="content__course-item"
          v-for="groupItem of group.content"
          :key="groupItem.uuid"
        >
          <CheckIcon
            size="24"
            class="content__check-icon"
            :class="{
              'content__check-icon--checked': isCourseFinished(groupItem),
            }"
          />

          <CourseItemCard
            v-if="groupItem.content_type === 'course'"
            :item="groupItem"
          />
          <LinkItemCard
            v-else-if="groupItem.content_type === 'link'"
            :item="groupItem"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { CheckIcon } from 'vue-feather-icons'
import { mapGetters, mapActions } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import { CourseItemCard, LinkItemCard } from './GroupItem'

export default {
  name: 'PlaylistContent',
  props: {
    playlistId: {
      type: String,
      required: true,
    },
  },
  components: {
    CourseItemCard,
    LinkItemCard,
    CheckIcon,
    ActionLoader,
  },
  computed: {
    ...mapGetters('playlists', ['playlistById']),
    playlistContent() {
      const playlist = this.playlistById(this.playlistId)
      return playlist ? playlist.content : []
    },
  },
  methods: {
    ...mapActions('playlists', ['getPlaylistById']),
    isCourseFinished(course) {
      const progress = course.user_status?.progress || 0
      return progress === 1
    },
  },
  async created() {
    await this.getPlaylistById({ id: this.playlistId })
  },
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
  border-radius: 0px 0px 10px 10px;
  background: linear-gradient(
    104.99deg,
    rgba(62, 63, 73, 0.7) -13.91%,
    rgba(62, 63, 73, 0) 100.48%
  );
  &__loader {
    display: flex;
    justify-content: center;
  }
  &__group {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0px;
    }
  }
  &__check-icon {
    color: var(--perfect-gray);
    margin-right: 10px;

    @include tablet {
      margin-right: 20px;
    }

    &--checked {
      color: var(--positive-light);
    }
  }
  &__section-title {
    font-family: var(--font-medium);
    font-size: rem(18px);
    line-height: 24px;
    color: var(--white);
  }
  &__course-list {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    gap: 10px 0px;
  }
  &__course-item {
    display: flex;
    align-items: center;
  }
}
</style>
